import React from 'react';
import Reveal from './Reveal';
import classNames from 'classnames';

export default ({
    header,
    posts,
}) => (
        <Reveal>
            <div className="post-grid grid-container contained mt1--md">
                <div className="row align--center">
                    <div className="col c12--sm">
                        <h1 className="mt12 mt2--lg domaine--large tc mb4 mb8--md">
                            {header}
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="post-grid__posts">
                            {createPostsGrid(posts)}
                        </div>
                    </div>
                </div>
            </div>
        </Reveal>
    );

/**
 * Creates the grid of posts.
 *
 * @param {Array<Object>} posts The posts from the cms.
 */
function createPostsGrid(posts) {
	let grid = [];

	posts.map(post => {
		grid.push(
			<a
				href={'/blog/' + post.slug.current + '/'}
				key={post._key}
				className='post-grid__post pr'
				onMouseEnter={ev => showButton(ev.currentTarget)}
				onMouseLeave={() => (post.hover = false)}>
				<div>
					<div className='bg--black'>
						<div className='image size--16x9 reveal__fade'>
							<picture>
								<source
									srcSet={`${post.featuredImage.url}?w=1000&auto=format&q=75`}
									media='(min-width: 600px)'
								/>
								<img
									alt={post.featuredImage.alt}
									src={`${post.featuredImage.url}?w=600&auto=format&q=75`}
								/>
							</picture>
						</div>
					</div>
					<div className='pt3 pb3 pt2--lg pb2--lg pl2 pr2 pl6--lg pr6--lg'>
						<span className='db uppercase sans--small fw--700 mb1'>
							{post.readLength} min read <span>&#183;</span> {formatDate(post.date)}
						</span>
						<h4 className='domaine--medium'>{post.title}</h4>
						<button
							name='add'
							type='submit'
							className={classNames('pa full-width button--primary-black dn')}>
							View Full Post
						</button>
					</div>
				</div>
			</a>,
		);
	});

	return grid;
}

/**
 * Shows the button when the post is being hovered over.
 *
 * @param {HTMLDivElement} post The post that is being hovered over.
 */
function showButton(post) {
	const button = post.querySelector('button');
	post.addEventListener('mouseleave', () => hideButton(post, button));
	button.classList.remove('dn');
}

/**
 * Hides the button when the post is no longer hovered over.
 *
 * @param {HTMLDivElement} post The post that was being hovered over.
 * @param {HTMLButtonElement} button The button to hide.
 */
function hideButton(post, button) {
	button.classList.add('dn');
}

/**
 * Formats the datetime from sanity to the format we want
 *
 * @param {string} date The date passed from sanity.
 */
function formatDate(date) {
	const dateObj = new Date(date);
	const month = dateObj.toLocaleString('default', { month: 'long' });

	return `${month} ${dateObj.getDate()}, ${dateObj.getFullYear()}`;
}